import { useEffect, useState } from "react";

/**
 * useMediaQuery — reactive media query matcher.
 *
 *   const isMobile = useMediaQuery("(max-width: 768px)");
 *
 * SSR-safe: returns `false` on the server and hydrates to the real value
 * on the client.
 */
export function useMediaQuery(query) {
  const getMatch = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const listener = (e) => setMatches(e.matches);

    // Initial sync (in case it changed between mount and effect)
    setMatches(mql.matches);

    // Older Safari uses addListener / removeListener
    if (mql.addEventListener) {
      mql.addEventListener("change", listener);
      return () => mql.removeEventListener("change", listener);
    }
    mql.addListener(listener);
    return () => mql.removeListener(listener);
  }, [query]);

  return matches;
}
